import Ad from './components';
import { handleAd } from './utils/handleAd';

export default Ad;
export { handleAd };
